import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RolesComponent } from './roles.component';
import { RolesRoutingModule} from './roles-routing.module';
import { RouterModule } from '@angular/router';
import { RolesCreateComponent } from './roles-create/roles-create.component';

import { FormsModule } from '@angular/forms';
import { RolesListComponent } from './roles-list/roles-list.component';
import { RoleDetailsComponent } from './role-details/role-details.component';
import { RoleEditComponent } from './role-edit/role-edit.component';
import { MyCustomMaterialModule } from 'san-common';

@NgModule({
  imports: [
      CommonModule,
      RouterModule,
      RolesRoutingModule,
      FormsModule,
      MyCustomMaterialModule,


    ],
  exports: [
      CommonModule,
      RouterModule,
      RolesRoutingModule,
      RolesComponent,
      RolesCreateComponent,
      RolesListComponent,
      RoleDetailsComponent,RoleEditComponent
    ],
  declarations: [
      RolesComponent,
      RolesCreateComponent,
      RolesListComponent,
      RoleDetailsComponent,RoleEditComponent
  ],
  providers: []
})
export class RolesModule { }
